import {StoreonModule} from 'storeon';
import {IEvents, IState} from 'src/store';

import {RoofType, roofFieldName} from './roofData/types';
import {RoofThickness} from "../types/types";

export type StepType = 1 | 2 | 3 | 4 | 5 | 6 ; // Тип кровли, Размеры, Профиль, Цвет, Покрытие, Результаты

export type MetalProfilesType = 'Металлочерепица' | 'Профнастил' ; // Металлочерепица | Профнастил

interface IRoofCalculations {
  id: number;
  name: string;
  measures: string;
  quantity: number;
  priceForOne: number;
  price: number;
  article: string;
  isInTotal: boolean;
}

const roofInitialData: IRoofCalculations[] = []

export interface IRoofStoreModule {
  stepID: StepType;
  // step1
  roofType: RoofType;
  // step2
  L_krValue: number | null;
  L_kValue: number | null;
  B_krValue: number | null;
  B_kr1Value: number | null;
  B_kr2Value: number | null;
  H_p1Value: number | null;
  H_p2Value: number | null;

  L_sk1Value: number | null;
  L_sk2Value: number | null;
  focusedField: roofFieldName | null

  //step3
  profileType: MetalProfilesType;
  metalTileName: string;
  pailingName: string;
  // step4
  colorID: number;
  // step5
  coatingName: string;
  thicknessName: RoofThickness;
  // step6 (result)
  roofCalculations: any;
  roofArea: number;
}

export interface IRoofState {
  roofStore: IRoofStoreModule;
}

export interface IRoofEvents {
  'roof/set-stepID': { stepID: StepType };
  // step1
  'roof/set-roof-type': { value: RoofType };
  // step2
  'roof/set-L_kr-value': { value: number | null };
  'roof/set-L_k-value': { value: number | null };
  'roof/set-B_kr-value': { value: number | null };
  'roof/set-B_kr1-value': { value: number | null };
  'roof/set-B_kr2-value': { value: number | null };
  'roof/set-H_p1-value': { value: number | null };
  'roof/set-H_p2-value': { value: number | null };

  'roof/set-L_sk1-value': { value: number | null };
  'roof/set-L_sk2-value': { value: number | null };
  'roof/set-focused-field': { focusedField: roofFieldName | null };

  // step3
  'roof/set-profile-type': { profileType: MetalProfilesType  };
  'roof/set-metalTile-name': { metalTileName: string };
  'roof/set-pailing-name': { pailingName: string };
  // step4
  'roof/set-color-id': { colorID: number };
  // step5
  'roof/set-coating-name': { coatingName: string };
  'roof/set-thickness-name': { thicknessName: RoofThickness };
  // step6 (result)
  'roof/set-roof-calculations': { roofCalculations: any };
  'roof/set-roof-area': { roofArea: number };
}

const initialState: IRoofStoreModule = {
  stepID: 1,
  // step1
  roofType: 'gambrel',
  // step2
  L_krValue: null,
  L_kValue: null,
  B_krValue: null,
  B_kr1Value: null,
  B_kr2Value: null,
  H_p1Value: null,
  H_p2Value: null,

  L_sk1Value: null,
  L_sk2Value: null,
  focusedField: null,

  // step3
  profileType: 'Металлочерепица',
  metalTileName: 'Ламонтерра',
  pailingName: 'МП20',
  // step4
  colorID: 1,
  // step5
  coatingName: '',
  thicknessName: RoofThickness.DEFAULT,
  // step6 (result)
  roofCalculations: roofInitialData,
  roofArea: 0,
}

export const roofStoreModule: StoreonModule<IState, IEvents> = (store) => {
  store.on('@init', () => ({
    roofStore: { ...initialState },
  }));
  store.on('roof/set-stepID', (state, payload) => ({
    roofStore: { ...state.roofStore, stepID: payload.stepID },
  }));
  // step1
  store.on('roof/set-roof-type', (state, payload) => ({
    roofStore: { ...state.roofStore, roofType: payload.value },
  }));
  // step2
  store.on('roof/set-L_kr-value', (state, payload) => ({
    roofStore: { ...state.roofStore, L_krValue: payload.value },
  }));
  store.on('roof/set-L_k-value', (state, payload) => ({
    roofStore: { ...state.roofStore, L_kValue: payload.value },
  }));
  store.on('roof/set-B_kr-value', (state, payload) => ({
    roofStore: { ...state.roofStore, B_krValue: payload.value },
  }));
  store.on('roof/set-B_kr1-value', (state, payload) => ({
    roofStore: { ...state.roofStore, B_kr1Value: payload.value },
  }));
  store.on('roof/set-B_kr2-value', (state, payload) => ({
    roofStore: { ...state.roofStore, B_kr2Value: payload.value },
  }));
  store.on('roof/set-H_p1-value', (state, payload) => ({
    roofStore: { ...state.roofStore, H_p1Value: payload.value },
  }));
  store.on('roof/set-H_p2-value', (state, payload) => ({
    roofStore: { ...state.roofStore, H_p2Value: payload.value },
  }));
  store.on('roof/set-focused-field', (state, payload) => ({
    roofStore: { ...state.roofStore, focusedField: payload.focusedField },
  }));


  store.on('roof/set-L_sk1-value', (state, payload) => ({
    roofStore: { ...state.roofStore, L_sk1Value: payload.value },
  }));
  store.on('roof/set-L_sk2-value', (state, payload) => ({
    roofStore: { ...state.roofStore, L_sk2Value: payload.value },
  }));

  // step3
  store.on('roof/set-profile-type', (state, payload) => ({
    roofStore: { ...state.roofStore, profileType: payload.profileType },
  }));
  store.on('roof/set-metalTile-name', (state, payload) => ({
    roofStore: { ...state.roofStore, metalTileName: payload.metalTileName },
  }));
  store.on('roof/set-pailing-name', (state, payload) => ({
    roofStore: { ...state.roofStore, pailingName: payload.pailingName },
  }));
  // step4
  store.on('roof/set-color-id', (state, payload) => ({
    roofStore: { ...state.roofStore, colorID: payload.colorID },
  }));
  // step5
  store.on('roof/set-coating-name', (state, payload) => ({
    roofStore: { ...state.roofStore, coatingName: payload.coatingName },
  }));
  store.on('roof/set-thickness-name', (state, payload) => ({
    roofStore: { ...state.roofStore, thicknessName: payload.thicknessName },
  }));
  // step6 (result)
  store.on('roof/set-roof-calculations', (state, payload) => ({
      roofStore: { ...state.roofStore, roofCalculations: payload.roofCalculations },
  }));
  store.on('roof/set-roof-area', (state, payload) => ({
    roofStore: { ...state.roofStore, roofArea: payload.roofArea },
  }));
};
